module.exports = __webpack_public_path__ + "img/wildlifevic.a283f74.png";